/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { useDispatch } from "react-redux";
import { cacheManager, removeAppCookies } from "../helpers/util-common";
import { logoutHandler } from "../helpers/OktaUtility";
import * as types from '../action-types'
const IdentityDelegationBanner = (identityDelegation) => {
    const { proxyMemberFirstName, proxyMemberLastName, accountNo } = identityDelegation;
    const dispatch = useDispatch();
    const signOut = () => {
        const isSignOutTrigger = true;
        dispatch({
            type: types.SIGN_OUT,
            payload: isSignOutTrigger
        });
        cacheManager.clearSession();
        removeAppCookies(false);
        logoutHandler();
    }
    return (
        <div>
            <div className="card astm-card astm-card--flat alert-danger">
                <div className="container">
                    <div className={"card-text d-flex flex-row justify-content-between pt-2 pb-2"}>
                        <span className={"astm-type-body--lead align-self-center renewal-reinstate-widget-descriptive-text mb0 text-danger"}>
                            <i className="astm-icon astm-icon astm-icon--light-danger fal fa-exclamation-square"></i>&nbsp;
                            Identity Delegation Active for - <b>{proxyMemberFirstName} {proxyMemberLastName} ({accountNo})</b></span>
                        <button className={"btn astm-btn btn-outline-danger align-self-center"} onClick={signOut}>Exit Delegation</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default IdentityDelegationBanner;